import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import { Box, useTheme } from '@material-ui/core';
import Check from '@material-ui/icons/Check'
import Remove from '@material-ui/icons/Remove'



// Inspired by blueprintjs
function StyledCheckbox(props) {
  const theme = useTheme()

  return (
    <Checkbox
      disableRipple
      color="default"
      checkedIcon={
        <Box display='flex' justifyContent='center' alignItems='center' width={18} height={18} bgcolor={props.checkedColor || theme.overrides.MuiButton.containedPrimary.backgroundColor} borderRadius={6}>
          <Check style={{ color: props.checkIconColor || 'white' }} fontSize='small' />
        </Box>}
      indeterminateIcon={<Box display='flex' justifyContent='center' alignItems='center' width={18} bgcolor={props.checkedColor || theme.overrides.MuiButton.containedPrimary.backgroundColor} height={18} borderRadius={6}>
        <Remove style={{ color: props.checkIconColor || 'white' }} fontSize='small' />
      </Box>}
      icon={<Box style={{ border: `2px solid ${props.borderColor || '#b4b5bd'}` }} width={14} height={14} bgcolor={props.iconColor === undefined ? 'white' : props.color} borderRadius={6}></Box>}

      inputProps={{ 'aria-label': 'decorative checkbox' }}
      {...props}
    />
  );
}

export default StyledCheckbox;
